<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" style="height: 35px;width: 35px;background: #009edb;padding: 7px 11px;border-radius: 5px;">
    <button (click)="scrollToTop()" style="color: #fff;">
        <i class="fa fa-chevron-up"></i>
    </button>
  </div>
  